import {isSmallScreen, isTallRatio} from "@/set/search/ScreenUtils";
import {ActionTree, GetterTree, MutationTree} from 'vuex'

const MAX_HISTORY = 10



export interface SearchHistory {
    date: Date
    sym: string
}

export interface ViewerConfig {
    engine: string
    split: boolean
    splitMode: string
    splitRatio: number
    showSidebar: boolean
}

export class SetState {
    history = [] as SearchHistory[]
    lang = 'th'
    viewerConfig = {
        engine: 'MS',
        split: !isSmallScreen(),
        splitMode: (isTallRatio()) ? 'vertical': 'horizontal',
        splitRatio: 66,
        showSidebar: !isSmallScreen()
    } as ViewerConfig
    useGoogleDriveViewer = false //for mobile
}

//eslint-disable-next-line  @typescript-eslint/no-explicit-any
const getters: GetterTree<SetState, any> = {
    historyReversed(state: SetState): SearchHistory[] {
        const res = []
        const length = state.history.length
        for (let i = 0; i < length; i++) {
            res.push(state.history[length - i - 1])
        }
        return res
    }
}

const mutations: MutationTree<SetState> = {
    addHistory(state, sym) {
        //see https://vuejs.org/v2/guide/list.html#Array-Change-Detection
        const i = state.history.findIndex(x => x.sym === sym)
        if (i >= 0) {
            state.history.splice(i, 1)
        }
        state.history.push({sym: sym, date: new Date()})
        if (state.history.length > MAX_HISTORY) {
            state.history.shift()
        }
    },
    toggleLang(state) {
        if (state.lang === 'th') {
            state.lang = 'en'
        } else {
            state.lang = 'th'
        }
    },
    toggleUseGoogleDriveViewer(state){
        state.useGoogleDriveViewer = !state.useGoogleDriveViewer
        console.log(state.useGoogleDriveViewer)
    },
    toggleSidebar(state){
      state.viewerConfig.showSidebar = !state.viewerConfig.showSidebar
    },
    hideSidebar(state){
        state.viewerConfig.showSidebar = false
    },
    toggleMode(state) {
        if (state.viewerConfig.splitMode === 'vertical') {
            state.viewerConfig.splitMode = 'horizontal'
        } else if (state.viewerConfig.splitMode === 'horizontal') {
            state.viewerConfig.splitMode = 'vertical'
        }
    },
    toggleEngine(state) {
        if (state.viewerConfig.engine === 'MS') {
            state.viewerConfig.engine = 'GG'
        } else {
            state.viewerConfig.engine = 'MS'
        }
    },
    increaseRatio(state) {
        state.viewerConfig.splitRatio += 10
        if (state.viewerConfig.splitRatio > 100) {
            state.viewerConfig.splitRatio = 100
        }
    },
    decreaseRatio(state) {
        state.viewerConfig.splitRatio -= 10
        if (state.viewerConfig.splitRatio < 0) {
            state.viewerConfig.splitRatio = 0
        }
    }
}

//eslint-disable-next-line  @typescript-eslint/no-explicit-any
const actions: ActionTree<SetState, any> = {}

const storeUser = {
    namespaced: true,
    state: new SetState(),
    getters: getters,
    mutations: mutations,
    actions: actions
}

export default storeUser